import React, { useState } from 'react'
import { Button } from '@paypalcorp/pp-react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Breakpoint } from '../lib/useBreakpoint'

type OnClickFN =
  | (((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) &
      ((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void))
  | undefined

const FADE_DURATION_MILLISECONDS = 2500

export const CheckmarkCopyButton = ({
  onClick,
  buttonText,
  clipboard,
  secondary,
  buttonStyles,
  breakpoint
}: {
  onClick?: OnClickFN
  buttonText: string
  clipboard: string
  secondary?: boolean | undefined
  buttonStyles?: string
  breakpoint: Breakpoint
}) => {
  const [state, setstate] = useState<'initial' | 'success'>('initial')
  const { isMobile } = breakpoint

  const handleState = () => {
    setstate('success')
    setTimeout(() => setstate('initial'), FADE_DURATION_MILLISECONDS)
  }

  return (
    <>
      <CopyToClipboard text={clipboard} onCopy={handleState}>
        <Button
          className={buttonStyles}
          size={isMobile ? 'sm' : undefined}
          secondary={secondary}
          onClick={onClick}
          btnState={state}
          screenReaderText={buttonText}
        >
          <span className="offer-details__button-span">{buttonText}</span>
        </Button>
      </CopyToClipboard>
    </>
  )
}

export default CheckmarkCopyButton
